import { ELanguages } from 'shared/typings';

export const LANGUAGES = () => [
	{
		//label: i18n.t('EN'),
		label: 'EN',
		value: ELanguages.EN,
	},
];

export const FULL_LANGUAGES = () => [
	{
		//label: i18n.t('English'),
		label: 'English',
		value: ELanguages.EN,
	},
];

export const DEFAULT_LANGUAGE = (language: ELanguages) => {
	return LANGUAGES().find(({ value }) => language.includes(value))?.value || ELanguages.EN;
};
